import React from "react";
import { GiftIcon } from "lucide-react";
import { bonuses } from "../data/content";
export function Bonuses() {
  return <section className="px-4 py-14 sm:px-5 sm:py-20" data-id="element-13" data-mp="pioa4qcb3aan">
      <div className="mx-auto max-w-3xl" data-id="element-14" data-mp="avcxel4e1k8y">
        <h2 className="text-center font-display text-3xl uppercase text-cream sm:text-5xl" data-id="element-15" data-mp="aua98kyg9vwq">
          + 6 bonus <span className="text-gold" data-id="element-16" data-mp="fsv6qcmbi1hh">offerts</span>
        </h2>
        <p className="mt-3 text-center font-serif text-lg italic text-mute sm:mt-4 sm:text-xl" data-id="element-17" data-mp="1tvj98ajjsmw">
          Inclus gratuitement avec votre livre aujourd'hui.
        </p>
        <ul className="mt-8 divide-y divide-line rounded-2xl border border-line bg-panel sm:mt-10" data-id="element-18" data-mp="5tnll39cd2jt">
          {bonuses.map((b, i) => <li key={b.title} className="flex items-start gap-3 px-4 py-4 sm:items-center sm:gap-4 sm:px-6" data-id="element-19" data-mp="3szwoh07trs0m" data-mpi={i}>
              <GiftIcon className="mt-0.5 h-5 w-5 shrink-0 text-gold sm:mt-0" aria-hidden data-id="element-20" data-mp="1mb9yf7pi3umj" />
              <div className="min-w-0 flex-1" data-id="element-21" data-mp="1r9l9flrj8b6c">
                <p className="text-xs font-bold text-gold sm:text-sm" data-id="element-22" data-mp="1r78rh8lry0ta">BONUS {i + 1}</p>
                <p className="text-sm text-cream sm:text-base" data-id="element-23" data-mp="3iclndrr6aixt">{b.title}</p>
              </div>
              <div className="shrink-0 text-right" data-id="element-24" data-mp="3detsqpz58ipx">
                <p className="text-xs text-mute line-through sm:text-sm" data-id="element-25" data-mp="3r79r3dh3nski">{b.value}</p>
                <p className="text-xs font-bold text-gold sm:text-sm" data-id="element-26" data-mp="3n5eqycawnl8b">OFFERT</p>
              </div>
            </li>)}
        </ul>
      </div>
    </section>;
}